export const STAR = 'star';
export const UNSTAR = 'unstar';

export type StarType = typeof STAR | typeof UNSTAR;
